import WINDOW from "../../../utils/window";
import pointermove from "../../listeners/events/pointer-move";
import scroll from "../../listeners/events/scroll";

const reloadGlobalListeners = () => {
  const listeners = /** @type {WindowListenersProps} */ (
    WINDOW.get("listeners")
  );

  const scrollFn = /** @type {Array<any>} */ (listeners.get("scroll"));
  const pointerFn = /** @type {Array<any>} */ (listeners.get("pointer"));

  if (scrollFn) {
    scroll(scrollFn[1]);
  }

  if (pointerFn) {
    pointermove(pointerFn[1]);
  }
};

export default reloadGlobalListeners;
